import { useEffect } from 'preact/hooks'
import { AccountSectionWrapper } from './AccountSectionWrapper'
import { accountTranslations } from '../helpers/translations'

/**
 * AccountAppointments
 * The JS script is loaded in the retailer-appointment.liquid snippet, which loads when the account page is loaded.
 * The script and iframe is then initialised when the user navigates to the 'Fitting Appointments' tab.
 */
export const AccountAppointments = () => {
  useEffect(() => {
    const handleScriptReady = () => {
      window.Brauz.initializeBrauzBookAStylist('SHOESANDSOX')
    }

    if (window.BrauzRetailerAppointmentScriptReady) {
      handleScriptReady()
    } else {
      document.addEventListener('BrauzRetailerAppointmentScriptReady', handleScriptReady)
      return () => {
        document.removeEventListener('BrauzRetailerAppointmentScriptReady', handleScriptReady)
      }
    }
  }, [])

  return (
    <AccountSectionWrapper title={accountTranslations.fitting_appointments.title}>
      <div data-role="customer-bookings">
        <div
          data-id="account-bookings"
          id="brauz-booking-manager-widget"
          data-sd={window.BrauzRetailerAppointmentConfig.shop_domain}
          data-ci={window.BrauzRetailerAppointmentConfig.customer_id}
        ></div>
      </div>
      <div className={'mt-10'}>
        <div className="flex flex-col gap-6 p-6 bg-secondary-yellow md:flex-row md:p-10">
          <div className="w-full md:w-1/2">
            <img
              src={
                accountGlobal.fittingBanner.image ||
                'https://shoesandsox.com.au/cdn/shop/files/MINI_SNEAKER_FREAKER_1187X1143_4f4eee3d-7d38-45f7-a297-84eb5aa3dcf5.png'
              }
              className="object-cover w-full aspect-4/3"
              alt="Banner image"
            />
          </div>
          <div className="flex flex-col w-full gap-4 md:w-1/2">
            <h2 className="leading-none h2">{accountGlobal.fittingBanner.title || 'Fitted With Care'}</h2>
            <p className="paragraph-md">
              {accountGlobal.fittingBanner.body ||
                'Our in-store fittings are 100% free of charge and available at all Shoes and Sox retailers. Our Fit Squad undergo a three month training course to ensure your kids feet and in the right hands. To skip the que and secure an appointment at a time that suits you, use the link below!'}
            </p>
            <div className="flex flex-wrap gap-4 mt-4 -mr-10">
              <a href="#brauz--book-a-fitting" className="btn btn-md btn-solid-black">
                {accountGlobal.fittingBanner.book_fitting || 'Book an expert fitting'}
              </a>
              <a href="/pages/book-a-fitting" className="btn btn-md btn-outline-black">
                {accountGlobal.fittingBanner.learn_more || 'Learn more'}
              </a>
            </div>
          </div>
        </div>
      </div>
    </AccountSectionWrapper>
  )
}
